








































































































































import { Component, Vue, Prop, PropSync } from "vue-property-decorator";
import EspecialidadeModel from "@/models/cadastros/saude/EspecialidadeModel";
import { ProfissionalModel } from "@/models/cadastros/saude/ProfissionalModel";
import { ValidationObserver } from "vee-validate";

@Component
export default class Profissionais extends Vue {
  $refs!: {
    profissionalObserver: InstanceType<typeof ValidationObserver>;
  };

  @Prop({ required: true })
  especialidades!: EspecialidadeModel[];

  @PropSync("profissionaisPrestador", { required: true })
  profissionaisPrestadorSynced!: ProfissionalModel[];

  profissional: ProfissionalModel = {
    especialidades: [],
  };

  indexProfissional = -1;

  editar(index: number) {
    this.profissional = Object.assign(
      {},
      this.profissionaisPrestadorSynced[index]
    );
    // remove especialidade que não existe no prestador;
    this.profissional.especialidades = this.profissional.especialidades.filter(
      (especialidadeProfissional) =>
        this.especialidades.find((e) => e.id == especialidadeProfissional.id)
    );
    this.indexProfissional = index;
  }

  remover(index: number) {
    this.profissionaisPrestadorSynced.splice(index, 1);
  }

  adicionarProfissional() {
    if (this.indexProfissional > -1) {
      this.profissionaisPrestadorSynced.splice(
        this.indexProfissional,
        1,
        Object.assign({}, this.profissional)
      );
    } else {
      this.profissionaisPrestadorSynced.push(this.profissional);
    }
    this.profissional = {
      especialidades: [],
    };
    this.$refs.profissionalObserver.reset();
    this.indexProfissional = -1;
  }
}
